// Only allow web, mail and phone links (or same-site paths); anything else (javascript:, data:) becomes inert.
export const safeHref = (url) => {
  const u = String(url || "").trim();
  if (/^(https?:|mailto:|tel:)/i.test(u) || (u.startsWith("/") && !u.startsWith("//"))) return u;
  return undefined;
};
